import dragAndDrop from './drag-and-drop';
/**
 * This method prevents the default behavior when dragging an external file into the browser.
 * For images the default behavior is to display the image in the browser replacing the application
 *
 * @private
 * @param {Object} event - browser generated (drag) event
 */

function preventDefaultForExternal(event) {
  if (dragAndDrop.isFileSystemDrag(event)) {
    event.preventDefault();
  }
}

export default {
  /**
   * This method adds all event listeners related to preventing the default
   * browser drag behavior for external files
   */
  start: function start() {
    window.addEventListener('dragstart', dragAndDrop.setEffectAllowed, false);
    window.addEventListener('dragover', preventDefaultForExternal, false);
    window.addEventListener('drop', preventDefaultForExternal, false);
  },

  /**
   * This method removes all event listeners related to preventing the default
   * browser drag behavior for external files
   */
  stop: function stop() {
    window.removeEventListener('dragstart', dragAndDrop.setEffectAllowed, false);
    window.removeEventListener('dragover', preventDefaultForExternal, false);
    window.removeEventListener('drop', preventDefaultForExternal, false);
  }
};